import { Navigate } from "react-router-dom";

import { LoadingLogo } from "@/components/shared/LoadingLogo";
import { useTenantSwitcher } from "@/contexts/TenantSwitcherContext";
import { useAuth } from "@/contexts/AuthContext";

interface TenantsRouteGuardProps {
  children: JSX.Element;
}

export function TenantsRouteGuard({
  children,
}: TenantsRouteGuardProps): JSX.Element {
  const { user, isLoading } = useAuth();
  const { activeTenant, loadingTenant } = useTenantSwitcher();

  if (isLoading || loadingTenant) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <LoadingLogo size="lg" />
      </div>
    );
  }

  const isRootOrAdmin =
    user?.platformRole === "root" || user?.platformRole === "root_admin";
  if (!isRootOrAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  if (activeTenant) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
